import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { LoginPage } from '../features/auth/pages/LoginPage';
import { DashboardPage } from '../features/dashboard/pages/DashboardPage';
import { ValidationPage } from '../features/orders/pages/ValidationPage';
import { CreateDossierPage } from '../features/orders/pages/CreateDossierPage';
import FactureRecap from '../features/billing/pages/FactureRecap';
import FactureAttente from '../features/billing/pages/FactureAttente';
import DossierPage from '../features/orders/pages/DossierPage';
import PaiementDashboard from '../features/paiement/pages/PaiementDashboard';
import PersonnelModule from '../features/personnel/pages/PersonnelModule';
import ReportingModule from '../features/reporting/pages/ReportingModule';
import AgentDashboard from '../features/agents/pages/AgentDashboard';
import { RoleBasedRedirect } from './RoleBasedRedirect';
import { NotFoundPage } from '../components/NotFoundPage';
import { ChangePasswordPage } from '../features/auth/pages/ChangePasswordPage';

export function AppRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<LoginPage />} />

            <Route path="/change-password" element={<ChangePasswordPage />} />

            {/* Redirection dynamique à la racine */}
            <Route path="/connecter" element={<RoleBasedRedirect />} />

            <Route element={<ProtectedRoute />}>
                <Route element={<DashboardLayout />}>
                    {/* Routes Administrateurs uniquement */}
                    <Route element={<ProtectedRoute allowedRoles={['ROLE_ADMIN', 'ROLE_CHEF_AGENCE']} />}>
                        <Route path="dashboard" element={<DashboardPage />} />
                        <Route path="personnel" element={<PersonnelModule />} />
                        <Route path="reporting" element={<ReportingModule />} />
                        <Route path="orders/validation" element={<ValidationPage />} />
                    </Route>

                    {/* Routes Agents uniquement */}
                    <Route element={<ProtectedRoute allowedRoles={['ROLE_AGENT']} />}>
                        <Route path="agent-dashboard" element={<AgentDashboard />} />
                    </Route>

                    {/* Routes Agents */}
                    <Route element={<ProtectedRoute allowedRoles={['ROLE_AGENT', 'ROLE_ADMIN', 'ROLE_CHEF_AGENCE']} />}>
                        <Route path="orders/create" element={<CreateDossierPage />} />
                        <Route path="orders" element={<DossierPage />} />
                        <Route path="factures/recap" element={<FactureRecap />} />
                        <Route path="factures/attente" element={<FactureAttente />} />
                        <Route path="factures/paiements" element={<PaiementDashboard />} />
                    </Route>
                </Route>
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}